import { render, staticRenderFns } from "./OurStyle.vue?vue&type=template&id=1ff4ca2c&scoped=true&"
import script from "./OurStyle.vue?vue&type=script&lang=js&"
export * from "./OurStyle.vue?vue&type=script&lang=js&"
import style0 from "./OurStyle.vue?vue&type=style&index=0&id=1ff4ca2c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff4ca2c",
  null
  
)

export default component.exports